import request from '@/utils/request'


// 商户列表
export const getShopList = function (data) {
    return request({
        url: '/v1/shop/getList',
        method: 'post',
        data: data
    })
}

// 商户列表
export const getShopLs = function (data) {
    return request({
        url: '/v1/shop/getListLs',
        method: 'post',
        data: data
    })
}

// 商户基本信息
export const getShopInfo = function (data) {
    return request({
        url: '/v1/shop/getInfo',
        method: 'get',
        params: data
    })
}

export default {
    getShopList,
    getShopLs,
    getShopInfo
}
